import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { reportsApi } from '@/api/index';

export const fetchReportTypes = createAsyncThunk(
  'reportTypes',
  async (_, thunkAPI) => {
    try {
      const response = await reportsApi.getAllReportTypes();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
